var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTitleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.871 24.8227L10.05 20.0097L12.063 17.9967L14.871 20.8047L20.479 15.1967L22.492 17.2097L14.871 24.8227ZM7.03333 29.8727C6.19378 29.8727 5.47833 29.5771 4.887 28.9857C4.29567 28.3944 4 27.679 4 26.8394V8.36406C4 7.52451 4.29567 6.80906 4.887 6.21773C5.47833 5.6264 6.19378 5.33073 7.03333 5.33073H8.271V2.66406H11.121V5.33073H21.421V2.66406H24.271V5.33073H25.5087C26.3482 5.33073 27.0637 5.6264 27.655 6.21773C28.2463 6.80906 28.542 7.52451 28.542 8.36406V26.8394C28.542 27.679 28.2463 28.3944 27.655 28.9857C27.0637 29.5771 26.3482 29.8727 25.5087 29.8727H7.03333ZM7.03333 26.8394H25.5087V13.6017H7.03333V26.8394ZM7.03333 10.9351H25.5087V8.36406H7.03333V10.9351Z",
    fill: "url(#paint0_linear_6627_187497)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6627_187497",
    x1: 4,
    y1: 2.66406,
    x2: 31.0646,
    y2: 27.0761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.224762,
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852864,
    stopColor: "#1D5AE8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleIcon);
export default __webpack_public_path__ + "static/media/TitleIcon.ac63776398e14722b374324faac253f2.svg";
export { ForwardRef as ReactComponent };